import React from "react";
import { Store } from "@storeLocator/storeType";
import OpenclosingTime from "./OpenClosingTime";
import CustomRadioGroupButton from "./CustomRadioGroupButton";
import { motion } from "framer-motion";

interface LeadFormSimpleChangeStoreProps {
  selectedStore: Store;
  threeStores: Store[];
  handleSelectStore: (store: Object) => void;
  closeChooseStore: () => void;
  chooseStore: () => void;
}

const LeadFormSimpleChangeStore = ({
  selectedStore,
  threeStores,
  handleSelectStore,
  closeChooseStore,
  chooseStore,
}: LeadFormSimpleChangeStoreProps) => {
  return (
    <div className="flex grow flex-col md:order-2">
      <motion.div
        className="right-section"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.4, delay: 0.2 }}
      >
        {threeStores.map((store, index) => (
          <div
            key={store.id}
            className="flex w-full grow flex-row items-center justify-between gap-[5px] border-t-2 border-armyGreen p-[15px] pr-0 last:border-b-2"
          >
            <div className="text-creamyWhite font-body text-base leading-[24px] tracking-[0.16px]">
              <p className="bold">{store.streetAndNumber}</p>
              <OpenclosingTime storeHours={store.openingHours} />
            </div>
            <CustomRadioGroupButton
              active={selectedStore.website === store.website}
              onClick={() => handleSelectStore(store)}
            />
          </div>
        ))}
      </motion.div>
    </div>
  );
};

export default LeadFormSimpleChangeStore;
